import * as z from 'zod'

import {buildEntrySchemaFor} from '../entry'
import {safeOptional} from '../../safe-optional'
import {FormFieldValidationSchema} from './formFieldValidation'

export const FormFieldSelectSchema = buildEntrySchemaFor('formFieldSelect', {
  fields: z.lazy(() =>
    z.object({
      htmlName: z.string(),
      label: z.string(),
      options: z.looseObject({}).catchall(z.string()),
      validations: safeOptional(z.array(FormFieldValidationSchema)),
    }),
  ),
})

export type FormFieldSelect = z.infer<typeof FormFieldSelectSchema>

export const isFormFieldSelect = (value: unknown): value is FormFieldSelect => {
  return FormFieldSelectSchema.safeParse(value).success
}
